import { Platform } from "react-native";

import type { UploadPlatform } from "@medbillai/utils/documentUpload";

// The web Rudder SDK leaves `context.os` empty, so web-mobile vs web-desktop is
// otherwise only recoverable by parsing user agents in the warehouse. This is a
// deliberately broader match than DownloadAppSheet's iOS-only sniff, which
// classifies every Android phone as desktop.
const MOBILE_WEB_USER_AGENT =
  /Android|iPhone|iPad|iPod|Mobile|Silk|Kindle|BlackBerry|Opera Mini|IEMobile/i;

// iPadOS Safari ships the desktop `Macintosh` UA by default; a Mac platform
// that reports touch points is the surviving signal that it's an iPad.
const isIpadWithDesktopUserAgent = (): boolean =>
  typeof navigator !== "undefined" &&
  navigator.platform === "MacIntel" &&
  navigator.maxTouchPoints > 1;

export const getUploadPlatform = (): UploadPlatform => {
  if (Platform.OS === "ios") {
    return "IOS";
  }
  if (Platform.OS === "android") {
    return "ANDROID";
  }
  const userAgent =
    typeof navigator === "undefined" ? "" : (navigator.userAgent ?? "");
  return MOBILE_WEB_USER_AGENT.test(userAgent) || isIpadWithDesktopUserAgent()
    ? "WEB_MOBILE"
    : "WEB_DESKTOP";
};
